export default class Utente{
    
    Token;
    DettagliUtente;

    constructor(){}
}